import { zoneColors } from '@/app/theme/colors';
import { WorkoutStatus } from '@/utils/prismaEnums';

export const analysisScoreColorMap = [
  [0.6, zoneColors['zone-5']],
  [0.7, zoneColors['zone-4']],
  [0.8, zoneColors['zone-3']],
  [1.0, zoneColors['zone-2']],
] as const;

export const getAnalysisScoreColor = (score: number) => {
  for (const [threshold, color] of analysisScoreColorMap) {
    if (score < threshold) {
      return color;
    }
  }
  return zoneColors['zone-2'];
};

const WORKOUT_STATUS_LABELS: Record<WorkoutStatus, string> = {
  [WorkoutStatus.PENDING]: 'Pending',
  [WorkoutStatus.COMPLETED]: 'Completed',
  [WorkoutStatus.SKIPPED]: 'Skipped',
};

const STATUS_STYLES: Record<
  WorkoutStatus,
  { border: string; text: string; bg: string }
> = {
  [WorkoutStatus.PENDING]: {
    border: 'border-amber-500',
    text: 'text-amber-700',
    bg: 'bg-amber-50',
  },
  [WorkoutStatus.COMPLETED]: {
    border: 'border-emerald-500',
    text: 'text-emerald-700',
    bg: 'bg-emerald-50',
  },
  [WorkoutStatus.SKIPPED]: {
    border: 'border-slate-300',
    text: 'text-slate-700',
    bg: 'bg-slate-50',
  },
};

export const ActivityAnalysisActions = ({
  status,
  onClick,
  disabled = false,
  title,
  labelOverride,
}: {
  status?: WorkoutStatus;
  onClick?: () => void;
  disabled?: boolean;
  title?: string;
  labelOverride?: string;
}) => {
  const normalizedStatus = status ?? WorkoutStatus.PENDING;
  const statusLabel =
    labelOverride ?? WORKOUT_STATUS_LABELS[normalizedStatus] ?? 'Pending';
  const style = STATUS_STYLES[normalizedStatus];
  const className = `inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${style.border} ${style.text} ${style.bg}`;

  if (onClick) {
    return (
      <button
        type='button'
        className={`${className} ${
          disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
        }`}
        onClick={onClick}
        disabled={disabled}
        title={title}
      >
        {statusLabel}
      </button>
    );
  }

  return <span className={className}>{statusLabel}</span>;
};
